import React, { Component } from 'react';
import Nav from './Header/Nav';
import SideBar from './sidebar/SideBar';
import Subscribe from './components/Subscribe';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { fab, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import Swal from 'sweetalert2';
import axios from 'axios';
import Footer from './components/Footer';
import codeflare from '../assets/images/codeflare.png';
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(fab, faWhatsapp);

class Develop extends Component {
    state = {
        name: '',
        email: '',
        phone: '',
        project: '',
        message: '',
      }

      handleFormSubmit( event ) {
        event.preventDefault();

        let formData = new FormData();
        formData.append('name', this.state.name)
        formData.append('email', this.state.email)
        formData.append('phone', this.state.phone)
        formData.append('message', this.state.message)

        if(this.state.name === ''){
          Swal.fire({
            title: 'Empty field',
            text: 'Please enter your name',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }else if(this.state.email === ''){
          Swal.fire({
            title: 'Empty field',
            text: 'Please enter your email address',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }else if(this.state.phone === ''){
          Swal.fire({
            title: 'Empty field',
            text: 'Please enter your phone number',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }else if(this.state.message === ''){
          Swal.fire({
            title: 'Empty field',
            text: 'Please tell us what project you would like to build',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }else{
        axios({
            method: 'post',
            url: 'https://codeflarelimited.com/api/develop-requests.php',
            data: formData,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then(function (response) {
           if(response.status === 200){
            Swal.fire({
                title: 'Success!',
                text: 'Message sent successfully',
                icon: 'success',
                confirmButtonText: 'OK'
              })
              .then(function() {
                // Redirect the user
                window.location.href = "https://codeflarelimited.com/catalogue";
                });
          }else{
            Swal.fire({
                title: 'Error!',
                text: 'An error occurred',
                icon: 'error',
                confirmButtonText: 'OK'
              })
          }
        })
        .catch(function (err) {
            //handle error
            Swal.fire({
                title: 'Error!',
                text: err,
                icon: 'error',
                confirmButtonText: 'OK'
              })
        });
    }
    }

      render(){
      return (
        <div id="App">
        <SideBar />
            <Nav />
        <div id="wrapper">
        <div id="left">
          <div id="signin">
            <div className="logo">
              <img src={codeflare} style={{ marginTop:'0vh'}} alt="Codeflare" />
            </div>
            <form>
              <div>
                <label>Full name</label>
                <input type="text" name="name" className="text-input" value={this.state.name}
                 onChange={e => this.setState({ name: e.target.value })}/>
              </div>
              <div>
                <label>Email</label>
                <input type="email" name="email" className="text-input" value={this.state.email}
                 onChange={e => this.setState({ email: e.target.value })}/>
              </div>
              <div>
                <label>Phone</label>
                <input type="tel" name="phone" className="text-input" value={this.state.phone}
                 onChange={e => this.setState({ phone: e.target.value })}/>
              </div>
              <div>
                <label>What project would you like to develop?</label>
                <textarea style={{height:'15vh'}}  name="message" className="text-input" value={this.state.message}
                 onChange={e => this.setState({ message: e.target.value })}></textarea>
              </div>

              <button type="submit" className="primary-btn fontw-weight-bold"
               onClick={e => this.handleFormSubmit(e)}>
                 Send Request
                 </button>
            </form>

          </div>
        </div>
        <div id="right">
          <div id="showcaseo">
            <div class="showcase-content-">
              <h1 class="showcase-text">
               Build Your Imagination.
              </h1>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
     <Footer />
      </div>
      );
    }
}

export default Develop;
